import type { RootState } from "@src/store/rootState";
import { getConfiguration } from "@src/store/slices/organization/selectors/getConfiguration";

/**
 * Redux twin of `useIsAgenticLogicEnabled` for code that runs outside React
 * (thunks assembling a request body). Same per-org toggle the backend gates
 * every Agentic Logic read on (`ConfigProvider.isAgenticLogicEnabled`), read
 * off the org's configurations rather than a separate flag so the builder,
 * the AI server and the serving gate cannot disagree about which rules
 * engine an upsell runs on.
 */
export const getIsAgenticLogicEnabled = (state: RootState): boolean =>
  !!getConfiguration<boolean>("agentic_logic_enabled")(state);
